export default interface ContactInfoActivity {
  type: Type;
  createdAt: string;
  createdBy: string;
}

export enum Type {
  NOTE_ADDED = "NOTE_ADDED",
  APPOINTMENT_REQUESTED = "APPOINTMENT_REQUESTED",
  APPOINTMENT = "APPOINTMENT",
  APPOINTMENT_CANCELED = "APPOINTMENT_CANCELED",
  REPORT_CREATED = "REPORT_CREATED",
  REPORT_AVAILABLE = "REPORT_AVAILABLE",
  REPORT_REJECTED = "REPORT_REJECTED",
  REPORT_FAILED = "REPORT_FAILED",
  REPORT_CANCELLED = "REPORT_CANCELLED",
  REPORT_INCOMPLETE = "REPORT_INCOMPLETE",
  REPORT_SHARED_WITH_PATIENT = "REPORT_SHARED_WITH_PATIENT",
  REPORT_VIEWED_BY_PATIENT = "REPORT_VIEWED_BY_PATIENT",
  MESSAGE_EMAIL = "MESSAGE_EMAIL",
  PATIENT_INVITED = "PATIENT_INVITED",
  PATIENT_ACCOUNT_CREATED = "PATIENT_ACCOUNT_CREATED",
  LEAD_CONVERTED = "LEAD_CONVERTED",
}
